import {
  FETCHING_COLLECTIONS_REQUEST, FETCHING_COLLECTIONS_SUCCEEDED, FETCHING_COLLECTIONS_FAILED,
  FETCHING_COLLECTION_REQUEST, FETCHING_COLLECTION_SUCCEEDED, FETCHING_COLLECTION_FAILED,
  FETCHING_COLLECTION_SECTION_REQUEST, FETCHING_COLLECTION_SECTION_SUCCEEDED, FETCHING_COLLECTION_SECTION_FAILED,
  GENERATE_COLLECTION_LINK_REQUEST, GENERATE_COLLECTION_LINK_SUCCEDDED, GENERATE_COLLECTION_LINK_FAILED,
  SEARCHING_COLLECTIONS_REQUEST, SEARCHING_COLLECTIONS_SUCCEEDED, SEARCHING_COLLECTIONS_FAILED,
  INVALIDATE_COLLECTIONS_SEARCH
}
  from 'constants/actionTypes.jsx';

import _ from "lodash";

const initialState = {
  loading: false,
  items: [],
  collection: {},
  pagination: {
    current: -1,
    totalPages: 0,
    totalRecords: 0
  },
  links: {},
  search: {
    searching: false,
    query: '',
    items: [],
    pagination: {
      current: -1,
      totalPages: 1
    }
  },
  error: null
}

const collectionState = {
  item: null,
  loading: false
}

const linkState = {
  generating: false
};

function collectionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_COLLECTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        pagination: {
          ...state.pagination
        }
      }
    case FETCHING_COLLECTIONS_SUCCEEDED: {
      var response = action.payload;
      var items = [...state.items, ...response.records];
     
      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.id == y.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: response.currentPage,
          totalPages: response.totalPages,
          totalRecords: response.totalRecordsCount,
        }
      }
    }

    case FETCHING_COLLECTIONS_FAILED:
      const error = _.get(action, 'payload.error', "Unknown error");

      return {
        ...state,
        loading: false,
        items: [...state.items],
        error: error
      }
    case FETCHING_COLLECTION_REQUEST:
      var id = action.payload.id;
      var collection = state.collection[id] || collectionState;

      return {
        ...state,
        collection: {
          ...state.collection,
          [id]: {
            ...collection,
            loading: true
          }
        }
      }
  case FETCHING_COLLECTION_SUCCEEDED: {
    const id = action.payload.id;
    const collection = state.collection[id] || collectionState;

    let item = action.payload.response;

    item = {
      ...item,
      sections: (item.sections || []).map(section => ({
        ...section,
        collectionId: id,
        loading: false,
      }))
    };

    return {
      ...state,
      collection: {
        ...state.collection,
        [id]: {
          ...collection,
          loading: false,
          item
        }
      }
    };
  }


    case FETCHING_COLLECTION_FAILED:
      var id = action.payload.id;
      var collection = state.collection[id] || collectionState;

      return {
        ...state,
        collection: {
          ...state.collection,
          [id]: {
            ...collection,
            loading: false
          }
        }
      }
    case FETCHING_COLLECTION_SECTION_REQUEST:
      var collectionId = action.payload.collectionId;
      var sectionId = action.payload.sectionId;

      var currentCollection = state.collection[collectionId] || collectionState;

      var sections = (currentCollection.item.sections || []).map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            loading: true,
          }
        } else {
          return section;
        }
      })
      return {
        ...state,
        collection: {
          ...state.collection,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      }

    case FETCHING_COLLECTION_SECTION_SUCCEEDED:
      var collectionId = action.payload.collectionId;
      var sectionId = action.payload.sectionId;

      var currentCollection = state.collection[collectionId] || collectionState;

      var sections = currentCollection.item.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            ...action.payload.response,
            loading: false,
          }
        } else {
          return section;
        }
      });

      return {
        ...state,
        collection: {
          ...state.collection,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      }
    case FETCHING_COLLECTION_SECTION_FAILED:
      var collectionId = action.payload.collectionId;
      var sectionId = action.payload.sectionId;

      var currentCollection = state.collection[collectionId] || collectionState;

      sections = currentCollection.item.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            loading: false,

          }
        } else {
          return section;
        }
      })

      return {
        ...state,
        collection: {
          ...state.collection,
          [collectionId]: {
            ...currentCollection,
            item: {
              ...currentCollection.item,
              sections: sections
            }
          }
        }
      }
      case GENERATE_COLLECTION_LINK_REQUEST:
      var id = action.payload.id;
      var link = state.links[id] || linkState;
      
      return Object.assign({}, state, {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            generating: true
          }
        }
      });

    case GENERATE_COLLECTION_LINK_SUCCEDDED:
      var id = action.payload.id;
      var response = action.payload.response;

      var link = state.links[id] || linkState;
      
      return Object.assign({}, state, {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            ...response,
            generating: false
          }
        }
      });

    case GENERATE_COLLECTION_LINK_FAILED: {
      var id = action.payload.id;
      const error = _.get(action, 'payload.error', "Unknown error");

      var link = state.links[id] || linkState;

      return Object.assign({}, state, {
        ...state,
        links: {
          ...state.links,
          [id]: {
            ...link,
            generating: false,
            error: error
          }
        }
      });  
    }

      case SEARCHING_COLLECTIONS_REQUEST:
        return{
          ...state,
          search: {
            ...state.search,
            searching: true,
            query: action.payload.query
          }
        }
  
      case SEARCHING_COLLECTIONS_SUCCEEDED:
        var query = action.payload.query;
        var response = action.payload.response;

        var items = [];
        if (response.currentPage == 0) {
          items = response.records;
        } else {
          items = [...state.search.items, ...response.records];
        }
  
        items = _.uniqBy(items, (a) => {
          return a.id;
        });

        return{
          ...state,
          search: {
            ...state.search,
            items: items,
            searching: false,
            query: query,
            pagination: {
              ...state.search.pagination,
              current: action.payload.response.currentPage,
              totalPages: action.payload.response.totalPages
            }
          }
        }
  
      case SEARCHING_COLLECTIONS_FAILED:
        return{
          ...state,
          search: {
            searching: false,
            query: '',
            items: [],
            error: action.payload.error,
            pagination: {
              current: -1,
              totalPages: 1
            }
          }
        };
  
      case INVALIDATE_COLLECTIONS_SEARCH:
        return{
          ...state,
          search: {
            searching: false,
            query: '',
            items: [],
            pagination: {
              current: -1,
              totalPages: 1
            }
          }
        };

    default:
      return state;
  }
}

export { collectionsReducer };